import React from 'react';

import "@ag-grid-community/styles/ag-grid.css";  /* Core grid CSS */
import "@ag-grid-community/styles/ag-theme-quartz.css";  /* quartz theme CSS */
import "./theme/ag-theme-sp.scss"
import './App.css';
import {LicenseManager} from "@ag-grid-enterprise/core";
import {ModuleRegistry} from "@ag-grid-community/core";
import {MenuModule} from "@ag-grid-enterprise/menu";
import {SetFilterModule} from "@ag-grid-enterprise/set-filter";
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';

import { useNavigate } from 'react-router';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import AppRoutes from './components/AppRoutes';
import config from './config';

const agGridLicenseKey = process.env.REACT_APP_AG_GRID_LICENSE_KEY;

if (agGridLicenseKey) {
    LicenseManager.setLicenseKey(agGridLicenseKey);
}

ModuleRegistry.registerModules([RichSelectModule, ExcelExportModule, MenuModule, SetFilterModule, ClientSideRowModelModule ]);

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {
    const navigate = useNavigate();
    const restoreOriginalUri = (_oktaAuth,  originalUri) => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    };


    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <AppRoutes/>
        </Security>
    );
}

export default App;
